// extracted by mini-css-extract-plugin
export default {"overlay":"KnowMe_overlay__PkW09","modal":"KnowMe_modal__l4vir","closeButton":"KnowMe_closeButton__UAGGN"};